export default "__VITE_ASSET__BFEvUdWb__"